import { render, staticRenderFns } from "./OpenDataStatusView.vue?vue&type=template&id=6fe00ac8&scoped=true"
import script from "./OpenDataStatusView.vue?vue&type=script&lang=js"
export * from "./OpenDataStatusView.vue?vue&type=script&lang=js"
import style0 from "./OpenDataStatusView.vue?vue&type=style&index=0&id=6fe00ac8&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe00ac8",
  null
  
)

export default component.exports